import { FC } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useSSRContext } from "../../../../context/SSRContext";
import { formulateSSRforPassengerTile } from "../../../../utils";
import { formulateName } from "src/utility";

const PassengerSelectionTile: FC<{ passenger: any, isActive:boolean }> = ({ passenger, isActive }) => {
  const { t } = useTranslation();
  const firstName = formulateName(passenger?.firstName);
  const lastName = formulateName(passenger?.lastName);
  const { cursor, getSSRItem } = useSSRContext();
  const ssrItem = getSSRItem(cursor.ssrType, passenger?.value);
  const SSRFormulated = formulateSSRforPassengerTile(ssrItem, cursor.ssrType);
  const nameInitials = `${firstName?.[0]}${lastName?.[0]}`.toUpperCase();
  return (
    <div className={classNames("flex w-full cursor-pointer select-none items-center gap-4 font-semibold h-full")}>
      <div className="bg-background-primary text-font-inverted flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-sm">
        {nameInitials}
      </div>
      <div className="flex flex-1 items-start justify-between gap-1 w-full h-full">
        <div className="flex flex-col flex-1 h-full ">
          <div className="text-font-hover flex items-center gap-1 text-base font-medium">
            <span>{firstName}</span>
            <span>{lastName}</span>
          </div>
          <span className="text-font-minimal text-xs font-normal">{`${t(`Flights.details.passengerType.${passenger?.type?.toLowerCase()}`)}`}</span>
        </div>
        <div className={classNames("text-font-hover text-base font-normal items-center h-full", isActive && "text-font-active! font-semibold!")}>
          {SSRFormulated}
        </div>
      </div>
    </div>
  );
};

export default PassengerSelectionTile;
